import React from 'react';
import { motion } from 'framer-motion';
export function Ornament({
  className = ''
}: {
  className?: string;
}) {
  return <motion.div initial={{
    opacity: 0,
    scale: 0.8
  }} whileInView={{
    opacity: 1,
    scale: 1
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.8,
    ease: 'easeOut'
  }} className={`flex items-center justify-center gap-3 py-3 opacity-80 ${className}`} data-id="element-254">
      <div className="h-[1px] w-12 bg-gradient-to-r from-transparent to-gold-500/50" data-id="element-255"></div>
      <div className="text-gold-500 text-lg" data-id="element-256">❖</div>
      <div className="h-[1px] w-12 bg-gradient-to-l from-transparent to-gold-500/50" data-id="element-257"></div>
    </motion.div>;
}